import { useEffect, useRef } from "react";

/** マウスの移動量に対してブロックを動かす割合（ログインテンプレートと同じ） */
const GRADIENT_MOVE_FACTOR = 0.5;

/**
 * 背景のグラデーション。auth0-customization-assets のログインテンプレート
 * （html/auth0-universal-login/body.html の .spcustom-gradation）と同じ配色・動きにする。
 * ページはスクロールするので、テンプレートと違って画面に固定する。
 * 動きを減らす設定（prefers-reduced-motion）のときは、拡大縮小もマウス追従もしない
 */
export function Background() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = ref.current;
    if (root === null) return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    const blocks = Array.from(root.querySelectorAll<HTMLElement>(".gradation__block"));
    const move = (x: number, y: number) => {
      for (const block of blocks) block.style.translate = `${x}px ${y}px`;
    };
    const onMove = (e: MouseEvent) => {
      const offsetX = e.clientX - window.innerWidth / 2;
      const offsetY = e.clientY - window.innerHeight / 2;
      move(offsetX * GRADIENT_MOVE_FACTOR, offsetY * GRADIENT_MOVE_FACTOR);
    };
    const onLeave = () => move(0, 0);
    document.addEventListener("mousemove", onMove);
    document.documentElement.addEventListener("mouseleave", onLeave);
    return () => {
      document.removeEventListener("mousemove", onMove);
      document.documentElement.removeEventListener("mouseleave", onLeave);
    };
  }, []);

  return (
    <div className="gradation" aria-hidden="true" ref={ref}>
      <div className="gradation__block gradation__block--1" />
      <div className="gradation__block gradation__block--2" />
      <div className="gradation__block gradation__block--3" />
      <div className="gradation__block gradation__block--4" />
    </div>
  );
}
